import { FormikProps } from "formik";
import { FC } from "react";
import lodash from "lodash";
import {classNames} from "utils";
import {SearchSelectInput, TextArea} from "../../core";
import {useQuery, gql} from "@apollo/client";
import {XMarkIcon} from "@heroicons/react/24/outline";

export * from "./schema";


const GET_MATERIALS = gql`
  query GetMaterialsSelect {
    materials: getMaterials(
      sort: "name"
      page: 0 pageSize: 0
    ) {
      _id
      code
      name
    }
  }
`;

interface GenerateMeterDeliveryMaterialsFormProps {
  form: FormikProps<{
    materials: {
      material: any,
      quantity: number,
    }[],
    notes: string,
  }>;
}

export const GenerateMeterDeliveryMaterialsForm: FC<GenerateMeterDeliveryMaterialsFormProps> = ({ form }) => {


  const { loading, data } = useQuery(GET_MATERIALS, {
    variables: {},
    notifyOnNetworkStatusChange: false,
  });


  return (
    <div className='space-y-6 divide-y divide-gray-200'>
      <div>
        <span className='text-xs font-light'>Complementary Materials Information</span>
        <div className=''>
          <div className="mt-2 pb-12">
            <table className="min-w-full divide-y divide-gray-200 bg-white border">
              <thead className="bg-gray-50">
              <tr>
                <th
                  scope="col"
                  className="pl-3 w-[40px] py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  No.
                </th>
                <th
                  scope="col"
                  className="px-0 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Material
                </th>
                <th
                  scope="col"
                  className="w-[100px] p-0 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Quantity
                </th>
                <th
                  scope="col"
                  className="w-[30px] p-0 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                </th>
              </tr>
              </thead>

              {/* Table Body */}
              <tbody className="divide-y divide-gray-200">
                {
                  lodash.times(
                    form.values.materials?.length + 1,
                    (idx) => {
                      const id = `materials.${idx}`;

                      return (
                        <tr key={idx} className="divide-x divide-gray-200">
                          <td className="p-0">
                            <input
                              key={idx}
                              type={"text"}
                              id={`index`}
                              name={`index`}
                              value={`${idx + 1}`}
                              placeholder={"eg. 1"}
                              disabled
                              className={classNames(
                                "focus:ring-primary-500 focus:border-primary-500 border-gray-200 bg-gray-50",
                                "block w-[40px] sm:text-sm placeholder:font-light placeholder:text-xs h-[38px] border-0 focus:border"
                              )}
                            />
                          </td>
                          <td className="p-0 flex-1">
                            <SearchSelectInput
                              {...form}
                              id={`${id}.material`}
                              placeholder={'-- Select --'}
                              labelHidden={true}
                              errorsHidden={true}
                              optionsLoading={loading}
                              options={(data?.materials ?? [])?.map((materials: any) => ({
                                label: {
                                  title: materials?.name as string,
                                },
                                value: materials?._id,
                              }))}
                            />
                          </td>
                          <td className="">
                            <input
                              key={idx}
                              type={"number"}
                              id={`${id}.quantity`}
                              name={`${id}.quantity`}
                              value={lodash.get(form.values, `${id}.quantity`, "")}
                              min={1}
                              step={1}
                              onChange={form.handleChange}
                              placeholder={"eg. 1"}
                              className={classNames(
                                "focus:ring-primary-500 focus:border-primary-500 border-gray-200",
                                "block w-[100px] sm:text-sm placeholder:font-light placeholder:text-xs h-[38px] border-0 focus:border"
                              )}
                            />
                          </td>
                          <td className="">
                            <button
                              disabled={idx === form.values.materials.length}
                              onClick={() => {
                                void form.setValues((prev) => ({
                                  ...prev,
                                  materials: prev.materials.filter((___, iddx) => iddx !== idx)
                                }))
                              }}
                              className={" grid place-items-center p-1 rounded-full hover:bg-gray-100 duration-150"}>
                              <XMarkIcon  className={"text-red-500 w-4 aspect-square"}  />
                            </button>
                          </td>
                        </tr>
                      );
                    })
                }
              </tbody>
            </table>
          </div>
          <div className={""}>
            <TextArea
              id="notes"
              label="Notes"
              placeholder="e.g. Additional notes..."
              rows={10}
              {...form}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenerateMeterDeliveryMaterialsForm;
